import React from "react";
import { ReactComponent as Fail } from "assets/icons/fail-payment.svg";
import { ReactComponent as Success } from "assets/icons/success-payment.svg";
import "./Billing.scss";
export const PaymentStatus = ({ status }) => {
  return (
    <div className="payment-status py-5">
      <div
        className="page-header"
        style={status === "fail" ? { color: "#F1585E" } : { color: "#4CAF50" }}
      >
        <span className="icon">
          {status === "fail" ? <Fail /> : <Success />}
        </span>
        <span className="header-text">
          {status === "fail" ? "Payment Failed" : "Payments paid Successfully"}
        </span>
      </div>
      <div className="status">
        {status === "fail"
          ? "The payment was not processed successfully please try again"
          : "Thank you for your payment.Your payment paid Successfully."}
      </div>
    </div>
  );
};
